import React from "react";

const UnifiedButtons = ({
  isEditable,
  isStartEnabled,
  isPending,
  onCreate,
  onStart,
  onEdit,
  onSaveEdit,
  onCancelEdit,
  onResetDB,
  onLog,
  onColumns,
  onDelete,
}) => {
  return (
    <div className="flex flex-col items-center justify-center gap-y-2">
      {isPending ? (
        <>
          <button
            onClick={onCreate}
            className="w-[90%] bg-blue-500 hover:bg-blue-400 font-bold py-2 px-4 rounded-lg transition duration-300 border border-white text-white text-sm"
          >
            Create
          </button>
          <button
            onClick={onStart}
            disabled={!isStartEnabled}
            className={`w-[90%] ${
              isStartEnabled
                ? "bg-green-500 hover:bg-green-400"
                : "bg-gray-500 cursor-not-allowed"
            } font-bold py-2 px-4 rounded-lg transition duration-300 border border-white text-white text-sm`}
          >
            Start
          </button>
        </>
      ) : isEditable ? (
        <>
          <button
            onClick={onSaveEdit}
            className="w-[90%] bg-green-500 hover:bg-green-600 font-bold py-2 px-4 rounded-lg transition duration-300 border border-white text-white text-sm"
          >
            Save
          </button>
          <button
            onClick={onCancelEdit}
            className="w-[90%] bg-red-500 hover:bg-red-600 font-bold py-2 px-4 rounded-lg transition duration-300 border border-white text-white text-sm"
          >
            Cancel
          </button>
        </>
      ) : (
        <>
          <button
            onClick={onResetDB}
            className="w-[90%] bg-gray-700 hover:bg-gray-600 font-bold py-2 px-4 rounded-lg transition duration-300 border border-white text-white text-sm"
          >
            Reset DB
          </button>
          <button
            onClick={onLog}
            className="w-[90%] bg-gray-700 hover:bg-blue-600 font-bold py-2 px-4 rounded-lg transition duration-300 border border-white text-white text-sm"
          >
            Log
          </button>
          {onColumns && (
            <button
              onClick={onColumns}
              className="w-[90%] bg-gray-700 hover:bg-blue-600 font-bold py-2 px-4 rounded-lg transition duration-300 border border-white text-white text-sm"
            >
              Columns
            </button>
          )}
          <button
            onClick={onEdit}
            className="w-[90%] bg-gray-700 hover:bg-yellow-500 font-bold py-2 px-4 rounded-lg transition duration-300 border border-white text-white text-sm"
          >
            Edit
          </button>
          <button
            onClick={onDelete}
            className="w-[90%] bg-red-600 hover:bg-red-500 font-bold py-2 px-4 rounded-lg transition duration-300 border border-white text-white text-sm flex items-center justify-center gap-2"
          >
            Delete
          </button>
        </>
      )}
    </div>
  );
};

export default UnifiedButtons;
